import { SortOptions } from '@ch/common/types/data';
import { optionsNormalize } from '@ch/common/utils/helpers';
import { DropdownData } from '../types';
import { loadFile } from './file';

interface LoadDropdownData {
  externalOptionFiles: string[];
  dropdownData: DropdownData;
  callback?: (data: DropdownData) => void;
  sortStrategy?: SortOptions;
}

export const preloadDropdownData = async ({
  externalOptionFiles,
  dropdownData,
  sortStrategy = SortOptions.NONE,
  callback = null,
}: LoadDropdownData): Promise<void> => {
  const loadedOptions: DropdownData[] = await Promise.all(
    externalOptionFiles.map(async (file: string) => {
      const optionsData = await loadFile(file);
      return {
        [file]: {
          displayedOptions: optionsNormalize(optionsData, sortStrategy),
          rawOptions: optionsData,
        },
      };
    }),
  );

  const data = loadedOptions.reduce((acc, item) => {
    acc = {
      ...acc,
      ...item,
    };
    return acc;
  }, dropdownData);

  callback?.(data);
};
